export default __webpack_public_path__ + "static/consent-uams-htn.pdf?860e2922e379";